export default __webpack_public_path__ + "static/media/mallory_mp_compact_bold.9b73ee2f.ttf";